import { render, staticRenderFns } from "./qwMessage.vue?vue&type=template&id=14edb164&scoped=true"
import script from "./qwMessage.vue?vue&type=script&lang=js"
export * from "./qwMessage.vue?vue&type=script&lang=js"
import style0 from "./qwMessage.vue?vue&type=style&index=0&id=14edb164&prod&lang=scss&scoped=true"
import style1 from "./qwMessage.vue?vue&type=style&index=1&id=14edb164&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14edb164",
  null
  
)

export default component.exports